export default __webpack_public_path__ + "static/media/solr.eaba0f3b.svg";